import { FormControlLabel, FormGroup, Switch } from '@mui/material'
import React, { useContext } from 'react'
import { AppContext } from '../../context'

interface InputBaseSwitchProps {
    label: string,
    value: boolean,
    setValue: (event: React.ChangeEvent<HTMLInputElement>) => void,
    disabled?: boolean
}

export default function InputBaseSwitch({ label, value, setValue, disabled }: InputBaseSwitchProps) {
    const appContext = useContext(AppContext)
    return (
        <FormGroup sx={{ pl: 3 }}>
            <FormControlLabel
                disabled={disabled || appContext?.loading}
                control={<Switch
                    checked={value}
                    onChange={setValue}
                    inputProps={{ 'aria-label': 'controlled' }}
                    disabled={disabled || appContext?.loading}
                />}
                label={label}
            />
        </FormGroup>
    )
}
